var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48549 0H30.5145C35.7533 0 40 4.24665 40 9.4855V30.5145C40 35.7534 35.7533 40 30.5145 40H9.48549C4.24664 40 0 35.7534 0 30.5145V9.4855C0 4.24665 4.24747 0 9.48549 0Z",
    fill: "#F9191D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3718 9.58722H11.6746C8.67152 9.58722 6.2373 12.0214 6.2373 15.0245V24.8217C6.2373 27.8248 8.67152 30.259 11.6746 30.259H28.3718C31.3749 30.259 33.8091 27.8248 33.8091 24.8217V15.0245C33.8083 12.0214 31.374 9.58722 28.3718 9.58722Z",
    fill: "#F8FAF8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9629 24.4562V15.3891C15.9629 14.6722 16.7442 14.2291 17.3594 14.597L24.9366 19.1306C25.5352 19.4886 25.5352 20.356 24.9366 20.714L17.3594 25.2475C16.7442 25.6155 15.9629 25.1723 15.9629 24.4562Z",
    fill: "#F9191D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.945e61f9e503dad7b48485a5ed53b4f6.svg";
export { ForwardRef as ReactComponent };